import Tooltip from './Tooltip'

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden>
    <path d="M9 16.2l-3.5-3.5L4 14.2 9 19l11-11-1.5-1.5z" fill="currentColor" />
  </svg>
)

const CrossIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden>
    <path
      d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      fill="currentColor"
    />
  </svg>
)

/**
 * Индикатор готовности аккаунта к использованию.
 * @param {boolean} isReady
 * @param {string} title  — текст тултипа
 * @param {string} [className] — дополнительный CSS-класс для span (без модификатора --ok/--bad)
 */
export default function AccountUsageIndicator({ isReady, title, className = '' }) {
  const modifier = isReady ? 'ok' : 'bad'
  return (
    <Tooltip text={title}>
      <span
        className={`${className}--${modifier} ${className}`}
        aria-label={title}
      >
        {isReady ? <CheckIcon /> : <CrossIcon />}
      </span>
    </Tooltip>
  )
}
